/**
 * @module Experince/Product-Selector
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// Core Libraries
import { Routes } from '@angular/router';

// Components
import { LineDetailComponent } from '@experience/shop/product-selector/components/selected-line-details/selected-line-details.component';
import { PrePurchasedPlanComponent } from '@experience/shop/product-selector/components/pre-purchased-plan/pre-purchased-plan.component';
import { ProductSelectorComponent } from '@experience/shop/product-selector/components/product-selector.component';
import { ProductSelectorLandingComponent } from '@experience/shop/product-selector/components/product-selector-landing/product-selector-landing.component';
import { ZipCodeRequiredGuardService } from '@experience/shop/services/zip-code-required-guard.service';

export const PRODUCT_SELECTOR_ROUTES: Routes = [
  {
    path: 'product-selector',
    component: ProductSelectorComponent,
    children: [
      {
        path: 'setup',
        component: ProductSelectorLandingComponent,
        children: [
          {
            path: ':tileId',
            canActivate: [ZipCodeRequiredGuardService],
            component: LineDetailComponent,
          },
        ],
      },
      {
        path: '',
        redirectTo: 'setup',
        pathMatch: 'full',
      },
      {
        path: 'activate',
        component: PrePurchasedPlanComponent,
      },
    ],
  },
];
